import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function StockStatusDropdown({ onSelect, selectedStatus }) {
    const [selectedItem, setSelectedItem] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);

    // Hardcoded stock status options
    const items = [
        { id: 'in_stock', name: 'In Stock' },
        { id: 'out_of_stock', name: 'Out of Stock' },
        { id: 'new_sides', name: 'New Sides' },
        { id: 'discontinued', name: 'Discontinued' },
    ];

    useEffect(() => {
        // Set the selected item based on the initial selectedStatus
        const foundItem = items.find((item) => item.id === selectedStatus);
        setSelectedItem(foundItem);
    }, [selectedStatus]);

    const handleSelectItem = (item) => {
        setSelectedItem(item);
        setShowDropdown(false); // Close dropdown after selection
        onSelect(item.id); // Notify parent component
    };

    return (
        <div className="relative">
            <label
                htmlFor="stock_status"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
                Stock Status
            </label>
            <button
                id="dropdownStockStatusButton"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 w-full text-left flex justify-between items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                type="button"
                onClick={() => setShowDropdown(!showDropdown)}
            >
                {selectedItem ? selectedItem.name : 'Select Stock Status'}
                <svg
                    className="ml-2 w-4 h-4"
                    aria-hidden="true"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                >
                    <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 8l5 5 5-5"
                    />
                </svg>
            </button>

            {showDropdown && (
                <div
                    className="absolute z-10 mt-1 bg-white divide-y divide-gray-100 rounded shadow w-full dark:bg-gray-700"
                    style={{
                        maxHeight: '20rem',
                        overflowY: 'auto',
                    }}
                >
                    <ul
                        className="py-1 text-sm text-gray-700 dark:text-gray-200"
                        aria-labelledby="dropdownStockStatusButton"
                    >
                        {items.map((item) => (
                            <li key={item.id}>
                                <a
                                    href="#"
                                    className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white text-xs"
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevent link navigation
                                        handleSelectItem(item);
                                    }}
                                >
                                    {item.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

StockStatusDropdown.propTypes = {
    onSelect: PropTypes.func.isRequired,
    selectedStatus: PropTypes.string,
};

export default StockStatusDropdown;
